import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Cake, GraduationCap, Waves, Briefcase, Users } from 'lucide-react';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { PageHero, SectionHeading } from '../components/PageBits';
import { Button } from '../components/ui/button';

const eventTypes = [
  { icon: Cake, title: 'Birthday Parties', desc: 'From milestone celebrations to first birthdays — our grounds transform for every era.' },
  { icon: Waves, title: 'Pool Parties', desc: '50,000-gallon pool, waterfall, slide, and jacuzzi with a certified lifeguard on duty.' },
  { icon: GraduationCap, title: 'Graduations', desc: 'A memorable outdoor celebration for high-school and college graduates and their families.' },
  { icon: Briefcase, title: 'Corporate & Private Events', desc: 'Retreats, launches, and gatherings in a setting your team will actually remember.' },
  { icon: Users, title: 'Family Celebrations', desc: 'Reunions, anniversaries, baby showers, and every-day milestones — hosted with warmth.' },
];

const Events = () => (
  <div className="min-h-screen bg-cream">
    <Nav transparent />
    <PageHero
      eyebrow="Beyond Weddings"
      title="Events at Queensland Ranch"
      subtitle="A private seven-acre estate ready for whatever life is worth celebrating."
      image="/hero/hero-main.jpg"
    />

    <section className="py-20 bg-cream texture-linen">
      <div className="container mx-auto px-6">
        <SectionHeading eyebrow="What We Host" title="Celebrations of" accent="Every Kind" />
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {eventTypes.map((e, i) => (
            <div key={i} className="bg-ivory border border-gold/25 rounded-lg p-8 shadow-sm hover:shadow-xl hover:border-gold/60 transition-all">
              <div className="w-12 h-12 rounded-full bg-navy flex items-center justify-center ring-2 ring-gold/40 ring-offset-4 ring-offset-ivory mb-5">
                <e.icon className="h-5 w-5 text-gold" />
              </div>
              <h3 className="font-serif text-xl text-navy mb-3 font-bold">{e.title}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{e.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center max-w-3xl mx-auto">
          <p className="text-slate-700 italic mb-6 text-lg leading-relaxed">
            Every event is a conversation with our family. Tell us the vision — we'll design the day.
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-navy hover:bg-navy/90 text-gold border border-gold/60 px-10 py-6 shadow-xl">
              <Calendar className="mr-2 h-5 w-5" />
              Check Availability
            </Button>
          </Link>
        </div>
      </div>
    </section>

    <Footer />
  </div>
);

export default Events;
